<template>
  <section class="staking-bg page-staking">
    <div class="container">
      <section class="card-wrapper">
        <div class="row justify-content-center align-item-center" v-if="!loading">
          <div class="col-md-4" v-for="(item, i) in stakes" :key="i">
            <HeroCards :stake="item" :index="i" v-on:transaction-done="init()" />
          </div>
          <div
            class="col-12 col-lg-4 col-md-4"
            v-for="index in stakes ? 3 - stakes.length : 3"
            :key="index"
          >
            <div class="large-card mb-5" @click="selectOption">
              <a href="JavaScript:void(0)" class="card-img">
                <i class="fa fa-plus fa-3x" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </section>
      <StakeModal v-if="isOpen" v-on:transaction-done="closeModal()" schema="heroes" />
    </div>
  </section>
</template>

<script>
import HelperService from "../services/index";
import HeroCards from "../components/HeroCards.vue";
import StakeModal from "../components/StakeModal.vue";
export default {
  name: "StakePage",
  components: { HeroCards, StakeModal },
  data() {
    return {
      isOpen: false,
      loading: true,
      stakes: null,
    };
  },

  mounted() {
    this.init();
    setTimeout(() => {
      if (this.stakes != null) {
        if (this.stakes.length > 3) {
          this.stakes.pop();
        }
      }
      this.loading = false;
    }, 2000);
  },
  methods: {
    selectOption() {
      this.isOpen = !this.isOpen;
    },
    closeModal() {
      this.selectOption();
      this.init();
    },
    init() {
      HelperService.getTable("hero.stake", null, (response) => {
        if (response) {
          this.stakes = response.filter(
            (item) => item.owner == localStorage.getItem("wax_user")
          );
          this.stakes = this.stakes.length > 0 ? this.stakes : [];
        }
      });
    },
  },
};
</script>

<style scoped>
.card-wrapper {
  width: 80%;
  /* border: 1px solid; */
  margin: 8rem auto;
  height: 100%;
  /* padding: 30px;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.35) !important;
  backdrop-filter: blur(10px); */
}

.large-card .card-img {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 280px;
  color: #fff;
  cursor: pointer;
  padding: 10px;
  /*padding: 26px 10px;*/
  width: 220px;
  border: 3px solid #fff;
  border-radius: 15px;
  margin: auto;
}

.button-wrapper a {
  color: brown !important;
}

.button-wrapper {
  width: 80%;
  margin: auto;
}

.button-wrapper .btn {
  width: 100%;
}

.btn {
  border: 0;
  border-radius: 7px;
  /* width: 100%; */
  text-align: center;
  padding: 3px 25px;
  margin-top: 5px;
  font-weight: bold;
  background: aqua;
  transition: all 0.4s;
}

.btn:hover {
  background: rgb(2, 135, 135);
}
</style>
